import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home/Home";
import Blog from "./pages/blog/Blog";
import BlogDetails from "./pages/blog/BlogDetails";
import Lmia from "./pages/lmiadb/Lmia";
import ContactUs from "./pages/ContactUs";
import TermsAndCondition from "./pages/TermsAndCondition/TermsAndCondition";
import AboutPage from "./pages/Home/AboutPage";
import HowItsWork from "./pages/HowItsWork";
import ResetPassword from "./pages/ResetPassword";

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog-details/:id" element={<BlogDetails />} />
          <Route path="/lmia" element={<Lmia />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/how-its-work" element={<HowItsWork />} />
          <Route path="/forgot-password" element={<HowItsWork />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
       
        </Routes>
    </Router>
  );
}

export default App;